/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddressResource
 */
export interface AddressResource {
    /**
     * 
     * @type {string}
     * @memberof AddressResource
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResource
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResource
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResource
     */
    countryCode: string;
    /**
     * The full country name
     * @type {string}
     * @memberof AddressResource
     */
    country: string;
    /**
     * Complete formatted address
     * @type {string}
     * @memberof AddressResource
     */
    formattedAddress: string;
}

/**
 * Check if a given object implements the AddressResource interface.
 */
export function instanceOfAddressResource(value: object): value is AddressResource {
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    return true;
}

export function AddressResourceFromJSON(json: any): AddressResource {
    return AddressResourceFromJSONTyped(json, false);
}

export function AddressResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressResource {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'countryCode': json['countryCode'],
        'country': json['country'],
        'formattedAddress': json['formattedAddress'],
    };
}

export function AddressResourceToJSON(value?: AddressResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'countryCode': value['countryCode'],
        'country': value['country'],
        'formattedAddress': value['formattedAddress'],
    };
}

